import React, { useCallback, useEffect, useRef, useState } from "react";
import { GET_ORDER_DETAIL } from "@/config/constConf";
import emitter from "@/lib/emitter";
import { useUserInfoContext } from "@/src/provider/UserInfo/context";

function checkExists(arg1: any, count = 30) {
    return new Promise((resolve, reject) => {
        function func(count: number) {
            if (count <= 0) {
                reject();
            } else {
                if (
                    (typeof arg1 === "function" && arg1()) ||
                    (typeof arg1 !== "function" && arg1)
                ) {
                    resolve("");
                } else {
                    setTimeout(() => func(count - 1), 1000);
                }
            }
        }
        func(count);
    });
}

interface IProps {}

const SetLCWithUserInfo: React.FC<IProps> = (props) => {
    const flag = useRef(0);
    const [ordersOid, setOrdersOid] = useState(0);
    const [userInfo] = useUserInfoContext((state) => [state.data]);

    // 设置LC的用户名、用户邮箱
    const setLCWithUserInfo = useCallback(
        async (userInfo: Record<string, any>) => {
            await checkExists(
                () =>
                    window.LC_API &&
                    typeof window.LC_API.set_visitor_name === "function",
                30,
            );
            const name =
                (userInfo.customers_firstname || "") +
                " " +
                (userInfo.customers_lastname || "");
            const email = userInfo.customers_email_address || "";
            window.LC_API.set_visitor_name(name);
            window.LC_API.set_visitor_email(email);
        },
        [],
    );

    // 设置LC的订单号
    const setLCWithOrder = useCallback(async (ordersOid: number | string) => {
        await checkExists(
            () => window.LC_API && typeof window.LC_API.call === "function",
            30,
        );

        window.LC_API.call("set_session_variables", {
            Account_ID: ordersOid,
        });
    }, []);

    // 在获取到userInfo后设置用户名、用户邮箱
    useEffect(() => {
        if (userInfo.customers_email_address) {
            if (!flag.current) {
                flag.current = 1;
                setLCWithUserInfo(userInfo);
            }
        }
    }, [setLCWithUserInfo, userInfo]);

    // 在获取到订单id后设置订单id
    useEffect(() => {
        if (ordersOid) {
            setLCWithOrder(ordersOid);
        }
    }, [ordersOid, setLCWithOrder]);

    useEffect(() => {
        const { searchParams } = new URL(window.location.href);
        let orderNo: number | string | null = searchParams.get("order");
        if (!orderNo) {
            orderNo = searchParams.get("order_id");
        }
        if (orderNo) {
            orderNo = parseInt(orderNo);
            if (orderNo !== ordersOid) {
                setOrdersOid(orderNo);
            }
        }
    }, [ordersOid]);

    // 订阅订单列表页的事件，获取订单信息
    useEffect(() => {
        const handler = (newOrdersOid: any) => {
            if (ordersOid !== newOrdersOid) {
                setOrdersOid(newOrdersOid);
            }
        };
        emitter.on(GET_ORDER_DETAIL, handler);
        return () => {
            emitter.off(GET_ORDER_DETAIL, handler);
        };
    }, [ordersOid]);

    return null;
};

export default SetLCWithUserInfo;
